module.exports = __webpack_public_path__ + "static/media/NonWord-Intro-AFTER-trail-exercises.59913e55.mp3";